module.exports = __webpack_public_path__ + "static/media/addNote.b1fb7268.svg";